<template>
	<layer class="opt_more_g" name="mode">
		<div class="box_opt_menu list_look_type">
			<div class="menu_item">
				<a href="javascript:" class="link_menu" @click="callback('view')">조회수</a>
			</div>
			<div class="menu_item">
				<a href="javascript:" class="link_menu" @click="callback('cmt')">댓글수</a>
			</div>
		</div>
	</layer>
</template>

<script>
import Layer from './Layer.vue';

export default {
	components: {Layer},
	props: {
		callback: {
			type: Function,
			default: () => null
		}
	}
}
</script>
